/**
 * Protege las rutas según RBAC: si el usuario no tiene permiso para la ruta actual,
 * redirige al dashboard. Evita acceso por URL directa (ej. /clients para rol RESERVATIONS).
 */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { canAccess } from '../rbac';
import { getPermissionKeyForPath } from '../rbac/routePermissionMap';

const RouteGuard = ({ location, history }) => {
  useEffect(() => {
    const pathname = (location && location.pathname) || '';
    if (pathname === '/login') return;

    const permissionKey = getPermissionKeyForPath(pathname);
    if (permissionKey === null) return;

    if (!canAccess(permissionKey)) {
      history.replace('/');
    }
  }, [location && location.pathname, history]);

  return null;
};

export default withRouter(RouteGuard);



// WEBPACK FOOTER //
// ./src/components/RouteGuard.js